// Componente para mostrar el estado del comercio actual
import React, { useState, useEffect } from 'react';
import { getComercioState, isComercioInicializado } from '../utils/comercioInit.js';
import { getComercioNombre } from '../config/comercio.js';

const ComercioStatus = () => {
  const [comercioState, setComercioState] = useState(null);
  const [loading, setLoading] = useState(true);

  // Función para calcular días restantes hasta el vencimiento
  const getDiasRestantes = () => {
    if (!comercioState?.token_vencimiento) {
      console.log('🔍 [VENCIMIENTO] No hay token_vencimiento');
      return null;
    }
    
    // Crear fechas solo con día, mes y año (sin horas)
    const fechaVencimiento = new Date(comercioState.token_vencimiento);
    fechaVencimiento.setHours(0, 0, 0, 0);
    
    const fechaActual = new Date();
    fechaActual.setHours(0, 0, 0, 0);
    
    const diferencia = fechaVencimiento.getTime() - fechaActual.getTime();
    const diasRestantes = Math.ceil(diferencia / (1000 * 60 * 60 * 24));
    
    console.log('🔍 [VENCIMIENTO] Fecha vencimiento (solo día):', fechaVencimiento.toDateString());
    console.log('🔍 [VENCIMIENTO] Fecha actual (solo día):', fechaActual.toDateString());
    console.log('🔍 [VENCIMIENTO] Días restantes:', diasRestantes);
    
    return diasRestantes;
  };

  // Función para determinar la clase CSS según los días restantes
  const getVencimientoClass = () => {
    const diasRestantes = getDiasRestantes();
    console.log('🔍 [VENCIMIENTO] Evaluando clase CSS, días restantes:', diasRestantes);
    if (diasRestantes !== null && diasRestantes <= 3 && diasRestantes >= 0) {
      console.log('🔍 [VENCIMIENTO] Aplicando clase warning');
      return 'status-item-warning';
    }
    console.log('🔍 [VENCIMIENTO] No se aplica clase warning');
    return '';
  };

  // Función para mostrar el mensaje de advertencia
  const getVencimientoWarning = () => {
    const diasRestantes = getDiasRestantes();
    console.log('🔍 [VENCIMIENTO] Evaluando mensaje de advertencia, días restantes:', diasRestantes);
    if (diasRestantes !== null && diasRestantes <= 3 && diasRestantes >= 0) {
      console.log('🔍 [VENCIMIENTO] Mostrando mensaje de advertencia');
      const shouldBlink = diasRestantes === 1;
      return (
        <div className={`vencimiento-warning ${shouldBlink ? 'blink' : ''}`}>
          ⚠️ Te faltan {diasRestantes} {diasRestantes === 1 ? 'día' : 'días'} para actualizar tu suscripción o el sistema dejará de funcionar
        </div>
      );
    }
    console.log('🔍 [VENCIMIENTO] No se muestra mensaje de advertencia');
    return null;
  };

  useEffect(() => {
    const checkComercio = () => {
      try {
        const state = getComercioState();
        const initialized = isComercioInicializado();
        
        console.log('🔍 [COMERCIO_STATUS] Estado actual:', state);
        console.log('🔍 [COMERCIO_STATUS] Inicializado:', initialized);
        console.log('🔍 [COMERCIO_STATUS] Fantasia:', state?.fantasia);
        console.log('🔍 [COMERCIO_STATUS] Token vencimiento:', state?.token_vencimiento);
        console.log('🔍 [COMERCIO_STATUS] Tipo de token_vencimiento:', typeof state?.token_vencimiento);
        
        // Forzar recálculo si hay token_vencimiento
        if (state?.token_vencimiento) {
          const fechaVencimiento = new Date(state.token_vencimiento);
          const fechaActual = new Date();
          fechaActual.setHours(0, 0, 0, 0);
          fechaVencimiento.setHours(0, 0, 0, 0);
          const diferencia = fechaVencimiento.getTime() - fechaActual.getTime();
          const diasRestantes = Math.ceil(diferencia / (1000 * 60 * 60 * 24));
          console.log('🔍 [COMERCIO_STATUS] Cálculo directo - Días restantes:', diasRestantes);
        }
        
        setComercioState({
          ...state,
          initialized
        });
        
        setLoading(false);
      } catch (error) {
        console.error('Error al verificar comercio:', error);
        setLoading(false);
      }
    };

    // Verificar solo una vez al montar el componente
    checkComercio();
  }, []);

  if (loading) {
    return (
      <div className="comercio-status loading">
        <div className="comercio-spinner"></div>
        <p>Verificando comercio...</p>
      </div>
    );
  }


  return (
    <div className="comercio-status">
      <h3>Estado del Comercio</h3>
      
      <div className="status-grid">
        <div className="status-item">
          <span className="label">ID:</span>
          <span className="value">{comercioState?.id || 'N/A'}</span>
        </div>
        
        <div className="status-item">
          <span className="label">Nombre:</span>
          <span className="value">{comercioState?.fantasia || comercioState?.nombre || 'N/A'}</span>
        </div>
        
        <div className="status-item">
          <span className="label">Inicializado:</span>
          <span className={`value ${comercioState?.initialized ? 'success' : 'error'}`}>
            {comercioState?.initialized ? '✅ Sí' : '❌ No'}
          </span>
        </div>
        
        <div className="status-item">
          <span className="label">Configuración:</span>
          <span className="value">Activo</span>
        </div>
        
        <div className={`status-item status-item-full ${comercioState ? getVencimientoClass() : ''}`}>
          <span className="label">Vencimiento:</span>
          <span className="value">
            {comercioState?.token_vencimiento ? 
              new Date(comercioState.token_vencimiento).toLocaleDateString('es-AR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }) : 
              'N/A'
            }
          </span>
          {comercioState ? getVencimientoWarning() : null}
        </div>
      </div>
      
        <div className="status-message">
          {comercioState?.initialized ? (
            <p className="success">🎉 Comercio {comercioState?.id || 'N/A'} ({comercioState?.fantasia || comercioState?.nombre || 'Comercio'}) configurado correctamente</p>
          ) : (
            <p className="error">⚠️ Comercio no inicializado</p>
          )}
        </div>
    </div>
  );
};

export default ComercioStatus;
